import {
  AUTH_ATTRIBUTES_CONSTANT,
  AUTH_MESSAGE_CONSTANT,
} from '@feature/auth/constants/auth-fields-constant';
import { PARTNER_LIST_ATTRIBUTES_CONSTANT } from '@feature/dashboard/partners/constant/partner-list.constant';
import { UPSERT_PARTNER_ATTRIBUTES_CONSTANT } from '@feature/dashboard/partners/constant/upsert-partner.constant';
import {
  CHANGE_PASSWORD_POPUP_ATTRIBUTES_CONSTANT,
  CHANGE_PASSWORD_POPUP_MESSAGE_CONSTANT,
} from '@feature/dashboard/profile/constant/change-password-popup-constant';
import { RECIPIENT_LIST_ATTRIBUTES_CONSTANT } from '@feature/dashboard/recipients/constant/recipient-list.constant';
import { UPSERT_RECIPIENT_ATTRIBUTES_CONSTANT } from '@feature/dashboard/recipients/constant/upsert-recipient.constant';
import { SENDER_LIST_ATTRIBUTES_CONSTANT } from '@feature/dashboard/senders/constant/sender-list.constant';
import { UPSERT_SENDER_ATTRIBUTES_CONSTANT } from '@feature/dashboard/senders/constant/upsert-sender.constant';
import {
  ADAPTER_SETTINGS_ATTRIBUTES_CONSTANT,
  ADAPTER_SETTINGS_MESSAGE_CONSTANT,
} from '@feature/dashboard/settings/adapter-settings/constant/adapter-settings.constant';
import {
  COUNTRY_SETTINGS_ATTRIBUTES_CONSTANT,
  COUNTRY_SETTINGS_MESSAGE_CONSTANT,
} from '@feature/dashboard/settings/country-settings/constant/country-settings.constant';
import { TRANSACTION_SETTINGS_ATTRIBUTES_CONSTANT } from '@feature/dashboard/settings/transaction-settings/constant/transaction-settings.constant';
import { UPSERT_VELOCITY_LIMIT_ATTRIBUTES_CONSTANT } from '@feature/dashboard/settings/velocity-limit/constant/upsert-velocity-limit.constant';
import { VELOCITY_LIMIT_LIST_ATTRIBUTES_CONSTANT } from '@feature/dashboard/settings/velocity-limit/constant/velocity-limit-list.constant';
import { CREATE_TRANSACTION_ATTRIBUTES_CONSTANT } from '@feature/dashboard/transactions/constant/create-transaction.constant';
import { TRANSACTION_DETAILS_ATTRIBUTES_CONSTANT } from '@feature/dashboard/transactions/constant/transaction-details.constant';
import { TRANSACTION_LIST_ATTRIBUTES_CONSTANT } from '@feature/dashboard/transactions/constant/transaction-list.constant';
import { UPSERT_PERMISSION_ATTRIBUTES_CONSTANT } from '@feature/dashboard/user-management/permissions/constant/upsert-permission.constant';
import { UPSERT_ROLE_ATTRIBUTES_CONSTANT } from '@feature/dashboard/user-management/roles/constant/upsert-role.constant';
import { ROLE_LIST_ATTRIBUTES_CONSTANT } from '@feature/dashboard/user-management/roles/constant/user-list.constant';
import {
  UPSERT_USER_ATTRIBUTES_CONSTANT,
  UPSERT_USER_MESSAGE_CONSTANT,
} from '@feature/dashboard/user-management/users/constant/upsert-user.constant';
import { USER_LIST_ATTRIBUTES_CONSTANT } from '@feature/dashboard/user-management/users/constant/user-list.constant';
import { ADD_WALLET_ATTRIBUTES_CONSTANT } from '@feature/dashboard/wallets/constant/add-wallet.constant';
import { WALLET_LIST_ATTRIBUTES_CONSTANT } from '@feature/dashboard/wallets/constant/wallet-list.constant';

export type AttrKeys = keyof typeof ATTRIBUTES_CONSTANT;

export const ATTRIBUTES_CONSTANT = {
  ...AUTH_ATTRIBUTES_CONSTANT,
  profile: {
    ...CHANGE_PASSWORD_POPUP_ATTRIBUTES_CONSTANT,
  },
  partners: {
    ...PARTNER_LIST_ATTRIBUTES_CONSTANT,
    ...UPSERT_PARTNER_ATTRIBUTES_CONSTANT,
  },
  wallets: {
    ...WALLET_LIST_ATTRIBUTES_CONSTANT,
    ...ADD_WALLET_ATTRIBUTES_CONSTANT,
  },
  transactions: {
    ...TRANSACTION_LIST_ATTRIBUTES_CONSTANT,
    ...TRANSACTION_DETAILS_ATTRIBUTES_CONSTANT,
    ...CREATE_TRANSACTION_ATTRIBUTES_CONSTANT,
  },
  senders: {
    ...SENDER_LIST_ATTRIBUTES_CONSTANT,
    ...UPSERT_SENDER_ATTRIBUTES_CONSTANT,
  },
  recipients: {
    ...RECIPIENT_LIST_ATTRIBUTES_CONSTANT,
    ...UPSERT_RECIPIENT_ATTRIBUTES_CONSTANT,
  },
  users: {
    ...USER_LIST_ATTRIBUTES_CONSTANT,
    ...UPSERT_USER_ATTRIBUTES_CONSTANT,
  },
  roles: {
    ...ROLE_LIST_ATTRIBUTES_CONSTANT,
    ...UPSERT_ROLE_ATTRIBUTES_CONSTANT,
  },
  permissions: UPSERT_PERMISSION_ATTRIBUTES_CONSTANT,
  settings: {
    countrySettings: COUNTRY_SETTINGS_ATTRIBUTES_CONSTANT,
    transaction: TRANSACTION_SETTINGS_ATTRIBUTES_CONSTANT,
    velocityLimit: {
      ...VELOCITY_LIMIT_LIST_ATTRIBUTES_CONSTANT,
      ...UPSERT_VELOCITY_LIMIT_ATTRIBUTES_CONSTANT,
    },
    adapter: ADAPTER_SETTINGS_ATTRIBUTES_CONSTANT,
  },
} as const;

const MESSAGE_CONSTANT = {
  ...AUTH_MESSAGE_CONSTANT,
  ...COUNTRY_SETTINGS_MESSAGE_CONSTANT,
  ...CHANGE_PASSWORD_POPUP_MESSAGE_CONSTANT,
  ...UPSERT_USER_MESSAGE_CONSTANT,
  ...ADAPTER_SETTINGS_MESSAGE_CONSTANT,
};

export const FIELDS_CONSTANT = {
  // Defines fields attributes values and data
  attributes: ATTRIBUTES_CONSTANT,
  // validation and other messages for fields
  message: MESSAGE_CONSTANT,
} as const;

export type Attribute = typeof ATTRIBUTES_CONSTANT;
